export default "__VITE_ASSET__RmtkUjXq__"